export default __webpack_public_path__ + "static/media/Tangerine-Bold.2456ce02.ttf";